/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ChevronRightCircle = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM9 6.56066L14.5003 12.0003L9.06067 17.5L10.1213 18.5607L15.5658 13.0659C16.1489 12.4774 16.1445 11.5276 15.556 10.9446L10.0607 5.5L9 6.56066Z"
                        fill={color}
                    />
                </svg>
        );
    };
